<template>

    <Head title="Standar Audit Mutu" />
    <Container>
        <template #header>
            <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
        </template>
        <template #default>
            <div>
                <Breadcrumbs :breadcrumbs="[
                    { name: 'Dashboard', href: route('dashboard') },
                    { name: 'Standar Audit', href: route('standarauditmutu.index') },
                ]" />

                <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
                    <!-- Form Column -->
                    <div class="order-2 col-span-1 space-y-6 lg:order-1">
                        <div class="bg-white border border-gray-200 shadow-lg rounded-xl">
                            <div
                                class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4">
                                <h2 class="flex items-center text-lg font-bold text-white sm:text-xl">
                                    <i class="mr-2 fa-solid fa-list-check sm:mr-3"></i>
                                    {{ form.id ? 'Edit Standar' : 'Tambah Standar' }}
                                </h2>
                            </div>
                            <div class="p-4 sm:p-6">
                                <form class="space-y-4" @submit.prevent="submit">
                                    <!-- Jenis Dokumen -->
                                    <div>
                                        <InputLabel for="jenis_id" value="Jenis Dokumen" class="mb-2" />
                                        <select id="jenis_id" v-model="form.jenis_id"
                                            class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200">
                                            <option value="">Pilih Jenis Dokumen</option>
                                            <option v-for="jenis in jenisOptions" :key="jenis.id" :value="jenis.id">
                                                {{ jenis.nama }}
                                            </option>
                                        </select>
                                        <InputError :message="form.errors.jenis_id" class="mt-2" />
                                    </div>
                                    <!-- Standar -->
                                    <div>
                                        <InputField label="Standar" icon="pen" v-model="form.standar" />
                                        <InputError :message="form.errors.standar" class="mt-2" />
                                    </div>
                                    <!-- Slug (optional manual override) -->
                                    <div>
                                        <InputField label="Slug (Opsional)" icon="link" v-model="form.slug" />
                                        <p class="mt-1 text-xs text-gray-500">Biarkan kosong untuk dibuat otomatis dari
                                            Standar.</p>
                                        <InputError :message="form.errors.slug" class="mt-1" />
                                    </div>
                                    <!-- Deskripsi -->
                                    <div>
                                        <InputLabel for="deskripsi" value="Deskripsi" class="mb-2" />
                                        <textarea id="deskripsi" v-model="form.deskripsi" rows="3"
                                            placeholder="Deskripsi singkat..."
                                            class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"></textarea>
                                        <InputError :message="form.errors.deskripsi" class="mt-2" />
                                    </div>
                                    <!-- Submit -->
                                    <div class="pt-4">
                                        <PrimaryBtn :disabled="form.processing"
                                            class="w-full px-4 py-2.5 text-sm font-semibold text-white bg-indigo-600 border border-transparent rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200">
                                            <i class="mr-2 fa-solid fa-floppy-disk"></i>
                                            {{ form.processing ? 'Menyimpan...' : form.id ? 'Update' : 'Simpan' }}
                                        </PrimaryBtn>
                                        <button v-if="form.id" type="button" @click="resetForm"
                                            class="w-full mt-2 px-4 py-2.5 text-sm font-semibold text-gray-700 bg-gray-100 border border-gray-300 rounded-lg shadow-sm hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors duration-200">
                                            <i class="mr-2 fa-solid fa-times"></i>
                                            Batal Edit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <!-- Data Column -->
                    <div class="order-1 col-span-1 lg:col-span-2 lg:order-2">
                        <div class="mb-4 sm:mb-6">
                            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                                <div>
                                    <h3 class="text-lg font-semibold text-gray-900">Daftar Standar</h3>
                                    <p class="mt-1 text-sm text-gray-600">Kelola standar audit mutu</p>
                                </div>
                                <div class="mt-2 text-sm text-gray-500 sm:mt-0">Total: {{ audits.total }} standar</div>
                            </div>
                        </div>

                        <!-- Search -->
                        <div class="relative mb-4">
                            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <MagnifyingGlassVue class="w-4 h-4 text-gray-400" />
                            </div>
                            <input v-model="search" type="text" autocomplete="off" placeholder="Cari standar..."
                                class="block w-full px-3 py-2.5 pl-10 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200" />
                        </div>

                        <!-- Desktop Table -->
                        <div
                            class="hidden overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 md:block md:rounded-lg">
                            <div class="overflow-x-auto">
                                <table class="min-w-full divide-y divide-gray-300">
                                    <thead class="bg-gray-50">
                                        <tr>
                                            <th
                                                class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                #</th>
                                            <th
                                                class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                                Jenis Dokumen</th>
                                            <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Standar</th>
                                            <th
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 min-w-[180px]">
                                                Slug</th>
                                            <th
                                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden lg:table-cell">
                                                Deskripsi</th>
                                            <th class="relative py-3.5 pl-3 pr-4 sm:pr-6"><span
                                                    class="sr-only">Aksi</span></th>
                                        </tr>
                                    </thead>
                                    <tbody class="bg-white divide-y divide-gray-200">
                                        <tr v-if="!audits.data || audits.data.length === 0">
                                            <td colspan="6" class="px-6 py-8 text-center text-gray-500">
                                                <div class="flex flex-col items-center">
                                                    <i class="mb-3 text-4xl text-gray-300 fa-solid fa-list-check"></i>
                                                    <p class="text-lg font-medium">Belum ada data standar</p>
                                                    <p class="text-sm">Gunakan form di kiri untuk menambah data baru</p>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-for="(row, index) in audits.data" :key="row.id"
                                            class="transition-colors duration-150 hover:bg-gray-50">
                                            <td
                                                class="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 whitespace-nowrap sm:pl-6">
                                                {{ getRowNumber(index) }}</td>
                                            <td class="px-3 py-4 text-sm text-gray-900 whitespace-nowrap">{{ row.jenis
                                                || '-' }}</td>
                                            <td class="px-3 py-4 text-sm font-medium text-indigo-600 whitespace-nowrap">
                                                {{ row.standar }}</td>
                                            <td class="px-3 py-4 text-sm text-gray-500 whitespace-nowrap">{{ row.slug }}
                                            </td>
                                            <td class="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">{{
                                                row.deskripsi }}</td>
                                            <td class="relative py-4 pl-3 pr-4 text-sm font-medium text-right sm:pr-6">
                                                <div class="flex items-center justify-end space-x-1 sm:space-x-2">
                                                    <button @click="editStandar(row)"
                                                        class="inline-flex items-center px-2 py-1 text-xs font-medium text-indigo-600 bg-indigo-100 rounded-md hover:bg-indigo-200 hover:text-indigo-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                                                        title="Edit">
                                                        <EditIcons class="w-3 h-3" />
                                                        <span class="hidden ml-1 sm:inline">Edit</span>
                                                    </button>
                                                    <button @click="deleteStandar(row.id, row.standar)"
                                                        class="inline-flex items-center px-2 py-1 text-xs font-medium text-red-600 bg-red-100 rounded-md hover:bg-red-200 hover:text-red-700 transition-colors duration-150 sm:px-2.5 sm:py-1.5"
                                                        title="Hapus">
                                                        <DeleteIcons class="w-3 h-3" />
                                                        <span class="hidden ml-1 sm:inline">Delete</span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Mobile Cards -->
                        <div class="space-y-4 md:hidden">
                            <div v-if="!audits.data || audits.data.length === 0"
                                class="p-8 text-center text-gray-500 bg-white border border-gray-200 rounded-lg">
                                <div class="flex flex-col items-center">
                                    <i class="mb-3 text-4xl text-gray-300 fa-solid fa-list-check"></i>
                                    <p class="text-lg font-medium">Belum ada data standar</p>
                                    <p class="text-sm">Gunakan form di atas untuk menambah data baru</p>
                                </div>
                            </div>
                            <div v-for="(row, index) in audits.data" :key="row.id"
                                class="p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                                <div class="flex items-start justify-between">
                                    <div class="flex-1 min-w-0">
                                        <div class="flex items-center space-x-2">
                                            <span class="text-xs font-medium text-gray-500">#{{ getRowNumber(index)
                                                }}</span>
                                            <span
                                                class="inline-flex items-center px-2 py-1 text-xs font-medium text-indigo-600 bg-indigo-100 rounded-full">{{
                                                row.jenis || '-' }}</span>
                                        </div>
                                        <h3 class="mt-1 text-sm font-medium text-gray-900 truncate">{{ row.standar }}
                                        </h3>
                                        <p class="mt-1 text-xs text-gray-500">{{ row.deskripsi }}</p>
                                        <p class="mt-1 text-[10px] text-gray-400">Slug: {{ row.slug }}</p>
                                    </div>
                                    <div class="flex ml-2 space-x-1">
                                        <button @click="editStandar(row)"
                                            class="inline-flex items-center px-2 py-1 text-xs font-medium text-indigo-600 transition-colors duration-150 bg-indigo-100 rounded-md hover:bg-indigo-200"
                                            title="Edit">
                                            <EditIcons class="w-3 h-3" />
                                        </button>
                                        <button @click="deleteStandar(row.id, row.standar)"
                                            class="inline-flex items-center px-2 py-1 text-xs font-medium text-red-600 transition-colors duration-150 bg-red-100 rounded-md hover:bg-red-200"
                                            title="Hapus">
                                            <DeleteIcons class="w-3 h-3" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Pagination -->
                        <Pagination :data="audits" :updatedPageNumber="updatedPageNumber" />
                    </div>
                </div>
            </div>
        </template>
    </Container>
</template>

<script setup>
import { Head, useForm, usePage, router } from '@inertiajs/vue3';
import { ref, computed, watch } from 'vue';
import Swal from 'sweetalert2';

import Container from '@/Layouts/Container.vue';
import Header from '@/Components/Header.vue';
import Breadcrumbs from '@/Components/Breadcrumbs.vue';
import InputField from '@/Components/InputField.vue';
import PrimaryBtn from '@/Components/PrimaryBtn.vue';
import InputError from '@/Components/InputError.vue';
import InputLabel from '@/Components/InputLabel.vue';
import Pagination from '@/Components/Pagination.vue';
import MagnifyingGlassVue from '@/Components/MagnifyingGlass.vue';
import EditIcons from '@/Components/Icons/EditIcons.vue';
import DeleteIcons from '@/Components/Icons/DeleteIcons.vue';

const props = defineProps({
    audits: { type: Object, required: true },
    jenisOptions: { type: Array, required: true },
    filters: { type: Object, required: false, default: () => ({}) }
});

const form = useForm({
    id: null,
    jenis_id: '',
    standar: '',
    slug: '',
    deskripsi: ''
});

const search = ref(props.filters.search || '');
const pageNumber = ref(1);

const listUrl = computed(() => {
    let url = new URL(route('standarauditmutu.index'));
    url.searchParams.set('page', pageNumber.value);
    if (search.value) url.searchParams.set('search', search.value);
    return url;
});

const updatedPageNumber = (link) => {
    if (!link || !link.url) return;
    const params = new URLSearchParams(link.url.split('?')[1] || '');
    const page = params.get('page');
    if (page) pageNumber.value = parseInt(page);
};

watch(() => listUrl.value, (url) => {
    router.visit(url.toString(), { preserveScroll: true, preserveState: true, replace: true });
});

watch(() => search.value, (val) => { if (val) pageNumber.value = 1; });

const getRowNumber = (index) => {
    const currentPage = props.audits.current_page || 1;
    const perPage = props.audits.per_page || 10;
    return (currentPage - 1) * perPage + index + 1;
};

const resetForm = () => { form.reset(); form.clearErrors(); };

const submit = () => {
    const isEdit = !!form.id;
    form[isEdit ? 'put' : 'post'](route(isEdit ? 'standarauditmutu.update' : 'standarauditmutu.store', isEdit ? form.id : {}), {
        onSuccess: () => {
            Swal.fire({
                icon: 'success',
                title: isEdit ? 'Berhasil Diperbarui!' : 'Berhasil Ditambahkan!',
                text: `Standar "${form.standar}" berhasil ${isEdit ? 'diperbarui' : 'ditambahkan'}.`,
                timer: 2800,
                showConfirmButton: false,
                toast: true,
                position: 'top-end',
                timerProgressBar: true,
                showCloseButton: true
            });
            resetForm();
        },
        onError: () => {
            Swal.fire({
                icon: 'error',
                title: isEdit ? 'Gagal Memperbarui!' : 'Gagal Menambahkan!',
                text: 'Terjadi kesalahan. Periksa data & coba lagi.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#dc3545'
            });
        }
    });
};

const editStandar = (row) => {
    form.id = row.id;
    form.jenis_id = row.jenis_id;
    form.standar = row.standar;
    form.slug = row.slug;
    form.deskripsi = row.deskripsi;
    document.querySelector('form')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

const deleteStandar = async (id, standar) => {
    const result = await Swal.fire({
        title: 'Konfirmasi Hapus',
        html: `Apakah Anda yakin ingin menghapus <b>${standar}</b>?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Ya, Hapus!',
        cancelButtonText: 'Batal',
        reverseButtons: true
    });
    if (result.isConfirmed) {
        const delForm = useForm({});
        delForm.delete(route('standarauditmutu.destroy', id), {
            onSuccess: () => {
                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil Dihapus!',
                    text: 'Standar berhasil dihapus.',
                    timer: 2500,
                    showConfirmButton: false,
                    toast: true,
                    position: 'top-end',
                    timerProgressBar: true,
                    showCloseButton: true
                });
            },
            onError: () => {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal Menghapus!',
                    text: 'Terjadi kesalahan saat menghapus.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#dc3545'
                });
            }
        });
    }
};
</script>
